import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import type { Pagination } from 'Types/pagination';
import type { VehicleListItem } from 'Types/vehicle';

import { VehicleCardV2 } from './VehicleCardV2/VehicleCardV2';
import { VehicleCardV2Skeleton } from './VehicleCardV2/VehicleCardV2Skeleton';
import { VehicleGridV2 } from './VehicleGridV2/VehicleGridV2';

import styles from './VehicleListV2.module.scss';

const SKELETON_COUNT = 12;

interface VehicleListV2Props {
	isLoading?: boolean;
	onLoadMore?: () => void;
	pagination?: Pagination;
	vehicles: VehicleListItem[];
}

export const VehicleListV2: React.FC<VehicleListV2Props> = ({ isLoading, onLoadMore, pagination, vehicles }) => {
	const { inView, ref: sentinelRef } = useInView({
		fallbackInView: false,
		rootMargin: '0px 0px 1344px 0px',
		threshold: 1,
	});

	useEffect(() => {
		if (inView && !isLoading && pagination?.hasMore) {
			onLoadMore?.();
		}
	}, [inView, isLoading, pagination?.hasMore, onLoadMore]);

	return (
		<div className={styles.container} data-testid="vehicle-list-v2">
			<VehicleGridV2>
				{vehicles.map((vehicle) => (
					<VehicleCardV2 key={vehicle.id} vehicle={vehicle} />
				))}
				{isLoading && Array.from({ length: SKELETON_COUNT }, (_, i) => <VehicleCardV2Skeleton key={`skeleton-${i}`} />)}
			</VehicleGridV2>
			{pagination?.hasMore && <div ref={sentinelRef} className={styles.sentinel} />}
		</div>
	);
};
